export default __webpack_public_path__ + "src/assets/github.487185be0b8e54697d02abc1222b9ae2.svg";